import React from 'react';
import { RouterProvider } from 'react-router';
import Router from './Routes/Router';
import 'react-image-crop/dist/ReactCrop.css';

// Redux
import { Provider } from 'react-redux';
import { store } from './Store/store';
import { Helmet } from 'react-helmet';

function App() {
  const prod = window.location.hostname === 'esign-proteantech.in';

  return (
    <div className='App'>
      <Helmet>
        <meta name='robots' content={prod ? 'index,follow' : 'noindex,follow'} />
        <meta name='googlebot' content={prod ? 'index,follow' : 'noindex,follow'} />
      </Helmet>

      <Provider store={store}>
        <RouterProvider router={Router} />
      </Provider>
    </div>
  );
}
export default App;
